<ng-container *ngIf="this.paymentSuccess">
    <app-loading class="col-12 text-center" *ngIf="this.loader" type="SMALL_LOADER">
    </app-loading>
    <ng-container>

        <div class="ui-g text-center">
            <div class="ui-g-12">
                <img src="assets/images/thank-you/successful.gif" alt="" class="successful-logo" />
            </div>
            <div class="ui-g-12">
                <p>Transaction is successful</p>
                <p>
                    <!-- Thank you for purchasing eGlobalDoctors License Plan. -->
                </p>
                <div class="ui-g-12 transaction-success-buttons">
                    <button pButton class="button-size" type="button" label="Navigate to Dashboard"
                        (click)="gotodashboard()"></button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-container *ngIf="!this.paymentSuccess">
    <div class="ui-g text-center">
        <div class="ui-g-12">
            <img src="assets/images/cancel.png" alt="" class="successful-logo" />
        </div>
        <div class="ui-g-12">
            <p>Transaction is cancelled</p>
            <p>
                Sorry, but the transaction was not processed.
            </p>
            <div class="ui-g-12 transaction-success-buttons">
                <button pButton class="button-size" type="button" label="Navigate to Dashboard"
                        (click)="gotodashboard()"></button>
            </div>
        </div>
    </div>
</ng-container>